import { useParams } from 'react-router-dom';
import { usePage } from '@/hooks/useApi';

export default function ContentPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: page, loading } = usePage(slug || '');

  if (loading) {
    return (
      <div className="container-main py-20 text-center">
        <div className="animate-pulse w-16 h-16 bg-cream-200 rounded-full mx-auto mb-4" />
        <p className="text-charcoal-400">جاري التحميل...</p>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="container-main py-20 text-center">
        <i className="ri-file-unknow-line text-4xl text-charcoal-300 mb-4 block" />
        <h2 className="text-xl font-bold text-charcoal-900 mb-2">الصفحة غير موجودة</h2>
        <p className="text-charcoal-500">عذراً، الصفحة التي تبحثين عنها غير متوفرة.</p>
      </div>
    );
  }

  return (
    <div className="container-main py-12 md:py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-charcoal-900 mb-8 text-right">
          {page.title}
        </h1>
        <div
          className="prose prose-base md:prose-lg max-w-none text-right rtl-content"
          dangerouslySetInnerHTML={{ __html: page.content || '' }}
        />
      </div>
    </div>
  );
}
